import { message } from 'antd';
import moment, { Moment } from 'moment';
import { every, find, intersection, isEmpty, isEqual, sortBy } from 'lodash';

import { IEventBreakdown, IEventFilter, ILandingEvent } from '@src/emp-3.0/types';

import {
  DROP_OFF_DISPLAY_NAME,
  OTHERS_NODE_DISPLAY_NAME,
  TIME_PICKER_REMINDING_MESSAGE,
} from '../constants';

export const isValidFilter = (filters: IEventFilter[][]): boolean =>
  filters.some((andFilter) => {
    return andFilter.some(
      (orFilter) => !isEmpty(orFilter.value) || (isEmpty(orFilter.value) && orFilter.is_all),
    );
  });

export function isSubsetArray<T = string>(arrayA: T[], arrayB: T[]): boolean {
  const arrayIntersection = intersection(arrayA, arrayB);
  return isEqual(sortBy(arrayIntersection), sortBy(arrayA));
}

export function isSubsetFilters(
  landingFilters: IEventFilter[],
  breakdownFilters: IEventFilter[],
): boolean {
  return every(landingFilters, (landingFilter) => {
    const matchingFilter = find(breakdownFilters, { field: landingFilter.field });
    if (matchingFilter?.is_all) {
      return true;
    }
    if (matchingFilter) {
      if (typeof matchingFilter.value === 'undefined' || matchingFilter.value.length === 0)
        return false;
      return isSubsetArray(landingFilter.value, matchingFilter.value);
    }
    return false;
  });
}

export const isLandingEvent = (
  eventData: ILandingEvent | IEventBreakdown,
): eventData is ILandingEvent => {
  return 'filters' in eventData;
};

export const isEventBreakdown = (
  eventData: ILandingEvent | IEventBreakdown,
): eventData is IEventBreakdown => {
  return 'breakdowns' in eventData;
};

// check is drop-off and other node
export const isDropOffOrOthersNode = (node) => {
  // TODO need backend add id to distinguish conviva other and custom other
  return isDropOffNode(node) || isOtherNode(node);
};

export const isOtherNode = (node) => {
  return node.event_name === OTHERS_NODE_DISPLAY_NAME;
};

export const isDropOffNode = (node) => {
  return node.event_name === DROP_OFF_DISPLAY_NAME;
};

export const isMoreThan15Days = (timestamps?: string | [Moment, Moment]) => {
  let moreThan15Days = false;
  if (!timestamps) return false;

  if (typeof timestamps === 'string') {
    const [startTime, endTime] = timestamps.split('/');
    const startDate = new Date(startTime);
    const endDate = new Date(endTime);
    const timeDifference = endDate.getTime() - startDate.getTime();
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
    moreThan15Days = daysDifference > 15;
  } else {
    const [startTime, endTime] = timestamps;
    if (startTime && endTime) {
      const duration = moment.duration(endTime.diff(startTime));
      const daysDifference = duration.asDays();
      moreThan15Days = daysDifference > 15;
    }
  }
  if (moreThan15Days) {
    message.error(TIME_PICKER_REMINDING_MESSAGE);
  }
  return moreThan15Days;
};
